export default {
  name: 'PageNavBackLayoutCpt',
  props: {
    showNavMargin: Boolean,
    title: String,
    rightText: String
  },
  data() {
    return {
      pageTitle: this.title || this.$route.name
    };
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$emit('clickRight');
    }
  }
};